import React from 'react';
import styled from 'styled-components';
import {VerticalSpacer} from '../../spacer';
import {Typography as Text} from '../../typography';
import {Button, CmsButtonProps} from '../../buttons';
import {AccentColorOptions, useBreakpointDown} from 'epic-ue-theme';
import {Image, ImageProps} from '../../images';
import Grid from '@material-ui/core/Grid';
import {AnimateOnViewWrap, WithCaption, WithCaptionProps} from '../../../wraps';
import {EmbeddedVideo, EmbeddedVideoProps} from '../../video';

const Styled = styled.div`
    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }

    .h3,
    .paragraph {
        ${(p) => p.theme.breakpoints.up('md')} {
            padding-right: 20px;
        }
    }
    .caption {
        padding-right: 8px;
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .MuiGrid-item.featured-card-big-title {
            padding-bottom: 0px;
        }

        .MuiGrid-item.featured-card-big-desc {
            padding-top: 15px;
        }
    }
`;

export interface FeaturesContentCardProps {
    title?: string;
    description?: string;
    links?: CmsButtonProps[];
    accentColor?: AccentColorOptions;
    image?: ImageProps;
    caption?: WithCaptionProps;
    variant?: 'video';
    embeddedVideo?: EmbeddedVideoProps;
}

export const FeaturesContentCardBig = ({
    title,
    description,
    links = [],
    accentColor = 'sky',
    image = {},
    caption,
    variant,
    embeddedVideo
}: FeaturesContentCardProps): JSX.Element => {
    const isSm = useBreakpointDown('sm');

    return (
        <Styled>
            <AnimateOnViewWrap translateY={60}>
                {variant === 'video' ? (
                    <EmbeddedVideo {...embeddedVideo} />
                ) : (
                    <WithCaption {...caption} tinyCaption={isSm}>
                        <Image {...image} />
                    </WithCaption>
                )}

                <VerticalSpacer variant="heading" />

                <Grid container spacing={8}>
                    <Grid item className="featured-card-big-title" xs={12} md={6}>
                        {title ? (
                            <>
                                <Text variant="h3" big>
                                    {title}
                                </Text>
                            </>
                        ) : (
                            ''
                        )}
                        {links && links.length ? (
                            <>
                                {!isSm && <VerticalSpacer variant="heading" />}
                                {links.map((link, index) => (
                                    <React.Fragment key={link.href}>
                                        {link.label && (
                                            <Button
                                                type="tertiary"
                                                color={accentColor}
                                                href={link.href}>
                                                {link.label}
                                            </Button>
                                        )}
                                        {!isSm && index < links.length - 1 ? (
                                            <VerticalSpacer variant="paragraph" />
                                        ) : (
                                            ''
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        ) : (
                            ''
                        )}
                    </Grid>
                    <Grid item className="featured-card-big-desc" xs={12} md={6}>
                        {description ? <Text variant="p">{description}</Text> : ''}
                    </Grid>
                </Grid>
            </AnimateOnViewWrap>
        </Styled>
    );
};
